import {
  AdminDollarInput,
  Button,
  Div,
  Modal,
  PropsModal,
  updateLocationReferralVDriveAgentEarningPlan,
  updateLocationReferralVOrdersAgentEarningPlan,
  reportError,
} from '@vgrubs/components';
import { AgentDetails } from 'components/src/types/location.types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const EditVDriveVOrderPlans = ({
  planAmount,
  modalIsOpen,
  closeModal,
  type,
  setLoading,
  id,
  setEarning,
  onSaved,
}: PropsModal & {
  planAmount: number;
  modalIsOpen: boolean;
  type: string;
  setLoading: Dispatch<SetStateAction<boolean>>;
  id: number;
  setEarning: Dispatch<SetStateAction<AgentDetails | null>>;
  onSaved?: () => void;
}) => {
  const [amount, setAmount] = useState(0);

  const planType = type === 'vTablet' ? 'vorders' : 'vdrive';

  const planTypeLabel = type === 'vTablet' ? 'SaaS Plan' : 'vDrive Sales Fee';

  useEffect(() => {
    setAmount(planAmount);
  }, [modalIsOpen]);

  async function handleEdit() {
    try {
      setLoading(true);
      const updateFunction =
        planType === 'vorders'
          ? updateLocationReferralVOrdersAgentEarningPlan
          : updateLocationReferralVDriveAgentEarningPlan;

      await updateFunction(id, amount);

      setEarning((prev) => {
        if (!prev) return null;
        if (type === 'vTablet') {
          return { ...prev, vOrdersCommision: amount };
        } else {
          return { ...prev, vDriveCommission: amount };
        }
      });

      // The service total changed, so the per-service agent shares are stale.
      onSaved?.();

      closeModal?.();
    } catch (error) {
      reportError(error);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Modal
      isOpen={modalIsOpen}
      closeModal={closeModal}
      logo={false}
      header={`${type} Earning Plans`}
      zIndex={110}
    >
      <AdminDollarInput
        prefix="$"
        value={amount / 100}
        onChange={(_, value) => setAmount(value * 100)}
        label={`Edit ${planTypeLabel}`}
        $textCenter
      />
      <Div $flex $gap="16px" $mt="24" $column>
        <Button $selected $w="100%" onClick={() => handleEdit()}>
          Save
        </Button>
        <Button $selected $gray $w="100%" onClick={() => closeModal?.()}>
          Cancel
        </Button>
      </Div>
    </Modal>
  );
};
